import React, { useRef, useState, useEffect, useContext } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../AppContext"; // Adjust the path as needed
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { format } from "date-fns";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear"; // This is the correct import

import { ListItemText } from "@mui/material";
import { MyDomain } from "../../App";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
          ? "70%"
          : window.innerWidth <= 3840
            ? "60%"
            : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));
const textFieldStyles = {
  "& .MuiInput-underline:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.5,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:hover:before": {
    borderBottomColor: "#a1a1aa",
    opacity: 0.8,
    borderBottomWidth: "1px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#6366f1",
    borderBottomWidth: "1px",
  },
  "& .MuiInputBase-root": {
    fontSize: "14px",
  },
};
// Add this in your component or in a <style> tag in your HTML
const styles = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

// Custom theme to override MenuItem and Select styles
const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#e5e5e5", // Change selected option background color to gray
            "&:hover": {
              backgroundColor: "#e5e5e5", // Keep the same color on hover
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingLeft: 0, // Remove left padding
          textAlign: "left", // Align text to the left
        },
      },
    },
  },
});
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function AdminProductsCreate() {
  const searchInputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  // Focus the search input when dropdown opens
  useEffect(() => {
    if (searchInputRef.current) {
      const timer = setTimeout(() => {
        searchInputRef.current.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [searchTerm]); // Re-run when searchTerm changes

  const today = new Date();
  const formattedDate = format(today, "dd-MM-yyyy");
  const [CheckDepartment, setCheckDepartment] = useState(true);

  const SelectStyles = {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom:
        CheckDepartment === false ? "1px solid red" : "1px solid #ccc",
      borderRadius: 0,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom: "1px solid #a1a1aa",
      borderRadius: 0,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom: "1px solid #a1a1aa",
      borderRadius: 0,
    },
    "& .MuiSelect-select": {
      paddingLeft: 0,
      textAlign: "left",
      fontSize: 14,
    },
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { User, Token } = useAppContext();
  const history = useHistory();
  const [Brands, setBrands] = useState([]);
  const [CategoriesData, setCategoriesData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    console.log("aa");
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(
        `${MyDomain}Products/GetAllNeedToCreateNewProduct`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          //params: { Id: User.userId },
        },
      );
      console.log(response.data);

      const newArrayBrands = response.data.brands.map((item) => ({
        value: item.name,
        label: item.name,
      }));
      const newArrayCategories = response.data.categories.map((item) => ({
        value: item.codeCat.toString(),
        label: item.secondNameCat,
      }));

      setBrands(newArrayBrands);
      setCategoriesData(newArrayCategories);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err.response.data.error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const [open, setOpen] = useState(false); //false
  const handleClose = () => {
    setOpen(false);
  };
  const [FirstName, setFirstName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [TheText, setTheText] = useState("");

  const [ProductOBJ, setProductOBJ] = useState({
    product: {
      //Fill All
      //"Id":0, Fill automatic
      //"ProductId":0, Fill automatic
      name: "", //Of course name of the product
      brand: "", //Need
      image: "",
      price: 0, //Need
      discount: 0, //Better be 0 when i create new product, then if i want change it !
      category: "",
      IsGift: 1, //1 its not gift 2 its gift
      NewsCodeCat: 0, //for first time be 0
      numberUsersRating: 0, //Should be 0 when create new product
      rating: "", //Should be 0 or "" when create new product,i thingshould be rating type int not string
      inWishList: "", //Empty, i think no need for this column!
      deals: "", //Give value as needed ("", Deal, Hit, ...)
      //"discId": "", // i should not send it its like Id and ProductId it Fill automatic
      inStock: "Yes", //when add new product i think should be in stock set it "Yes"
      DropDown: "", //Just for example most of times for perfumes be like 100 ml, 50 ml for every product there is hes DropDown
      TheDeal: 1, //When do discount if the deal 1 the discount for every product if like 2 the discount on the secont product ...
      DropDownOrDialog: 1, //When click on dropdown if DropDownOrDialog=1 open normal dropdown if = 2 it will open dialog (i dont use it in ProductDisc page)
      mainimage: "", // Some times i should set like Image that shouw the main image (most used like for makeup)
      DatePost: formattedDate, // Date i post the product
      CheckGiftName: "", //if for regular product set "" put if for Gift enter name to find it in News in Top  section to equal to CheckGiftName name !
      DateCreateProduct: formattedDate, // Date i post the product
      BigCategoryFilter: "", // Always Need (to use for filter) // should set the main cat like 1000 then we can also do (1000, 1002 ...)
      priceInsteadOf: 0,
      mainPageCallCatName: "",
      //End Fill All
      //Here Fill by category needs!
      productType: "Eau de parfum", //Need
      classfication: "Elite", //Need
      productProperties: "", //Need
      gender: "For women", //Need
      scentType: "", //Need
      topNote: "", //Need
      heartNote: "", //Need
      baseNote: "", //Need
      ingredients: "", //Need
      specialCertificates: "", //Need
      volume: "", //Need
      madeIn: "France", //Need
      color: "", // XXX
      ProtectionLevel: "", // XXX
      EyeshadowEffect: "", // XXX
      Formula: "", // XXX
      country: "", // XXX
      HairType: "", // XXX
      BrushMaterial: "", // XXX
      SkinType: "", // XXX
      age: "", // XXX
      Line: "", // XXX
    },
    productDisc: {
      characteristics: "Characteristics",
      discreption: "Description",
      howToUse: "Instructions",
    },
  });
  const [imageFile, setImageFile] = useState(null);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setProductOBJ((prevState) => ({
      ...prevState,
      product: {
        ...prevState.product,
        [name]: value,
      },
    }));

    console.log(ProductOBJ);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);

    // Optional: show filename or image preview
    setProductOBJ((prev) => ({
      ...prev,
      product: {
        ...prev.product,
        image: file.name,
      },
    }));
  };

  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");
  const prefix = "+972";

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Ensure the input starts with the prefix
    if (!inputValue.startsWith(prefix)) {
      inputValue = prefix;
    }

    // Extract the digits after the prefix
    let phoneDigits = inputValue.slice(prefix.length);

    // Remove extra spaces
    phoneDigits = phoneDigits.replace(/\s+/g, "");

    // Limit to max length (excluding prefix)
    if (phoneDigits.length > 9) {
      phoneDigits = phoneDigits.slice(0, 9); // 9 digits after prefix
    }

    // Format: Insert a space after the first two digits
    if (phoneDigits.length > 2) {
      phoneDigits = phoneDigits.slice(0, 2) + " " + phoneDigits.slice(2);
    }

    // Update state
    setPhoneNumberDataBase(prefix + phoneDigits.replace(/\s+/g, "")); // Store without spaces
    setPhoneNumber(prefix + " " + phoneDigits);
  };

  const handleFocus = () => {
    if (!PhoneNumber.startsWith(prefix)) {
      setPhoneNumber(prefix);
    }
  };
  // Your department options (can be in a separate config file)
  const ItIsGift = [
    { value: 1, label: "It's not gift" },
    { value: 2, label: "It's Gift" },
  ];

  const ItIsInStock = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  const TheDeal = [
    { value: 1, label: "No Deal" },
    { value: 2, label: "Deal" },
  ];

  const Gender = [
    { value: "For men", label: "For men" },
    { value: "For women", label: "For women" },
    { value: "Unisex", label: "Unisex" },
    { value: "For boys", label: "For boys" },
    { value: "For girls", label: "For girls" },
    { value: "Kids unisex", label: "Kids unisex" },
  ];

  const DropDownOrDialog = [
    { value: 1, label: "Drop down" },
    { value: 2, label: "Dialog" },
  ];

  const Categories = [
    { value: "Perfume", label: "Perfume" },
    { value: "Makeup", label: "Makeup" },
    { value: "Hair", label: "Hair" },
    { value: "Face", label: "Face" },
    { value: "Bath and Body", label: "Bath and Body" },
    { value: "For Men", label: "For Men" },
    { value: "Accessories", label: "Accessories" },
    { value: "Health and Care", label: "Health and Care" },
    { value: "Gifts", label: "Gifts" },
  ];

  const MainPageCategories = [
    { value: "Dubai Perfumes", label: "Dubai Perfumes" },
    { value: "Perfume", label: "Perfume" },
    { value: "Womens bags", label: "Womens bags" },
    { value: "Womens wallet", label: "Womens wallet" },
    { value: "Set bags", label: "Set bags" },
    { value: "Womens watches", label: "Womens watches" },
    { value: "Accessories", label: "Accessories" },
  ];

  const [ChooseCat, setChooseCat] = useState("Perfume");

  const ChoosingCategory = [
    "Perfume",
    "Makeup",
    "Hair",
    "Face",
    "Bath and Body",
    "For Men",
    "Accessories",
    "Health and Care",
    "Gifts",
  ];

  // for brand
  const [searchTermBrands, setSearchTermBrands] = useState("");

  const handleChangeBrands = (event) => {
    const selectedValue = event.target.value;
    // setProductOBJ((prev) => ({
    //   ...prev,
    //   brand: selectedValue,
    // }));

    setProductOBJ((prevState) => ({
      ...prevState,
      product: {
        ...prevState.product,
        brand: selectedValue,
      },
    }));
    console.log(ProductOBJ);
  };

  const clearSearch = () => {
    setSearchTermBrands("");
    setTimeout(() => searchInputRef.current?.focus(), 0);
  };

  const filteredBrands = Brands.filter(
    (option) =>
      option.label.toLowerCase().includes(searchTermBrands.toLowerCase()) ||
      option.value
        .toString()
        .toLowerCase()
        .includes(searchTermBrands.toLowerCase()),
  );
  //End for brand

  // for brand
  const selectedValuesBigCategoryFilter = ProductOBJ.product.BigCategoryFilter
    ? ProductOBJ.product.BigCategoryFilter.split(", ")
    : [];
  const [searchTermBigCategoryFilter, setSearchTermBigCategoryFilter] =
    useState("");

  const handleChangeBigCategoryFilter = (event) => {
    console.log(event);
    const {
      target: { value },
    } = event;

    // Convert array back to string for your state
    const newValue = typeof value === "string" ? value : value.join(", ");
    console.log(newValue);

    // setProductOBJ((prev) => ({
    //   ...prev,
    //   BigCategoryFilter: newValue,
    // }));

    setProductOBJ((prevState) => ({
      ...prevState,
      product: {
        ...prevState.product,
        BigCategoryFilter: newValue,
      },
    }));
    console.log(ProductOBJ);
  };

  //End for brand
  const ModalCreateNewProduct = () => {
    return (
      <div>
        <style>{styles}</style>

        <React.Fragment>
          {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              CREATE NEW PRODUCT
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>

            <div
              style={{
                width: "100%",
                display: "flex",
                //flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  //height: "calc(90vh - 55px)",
                  //minHeight: "calc(60vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", width: "100%" }}>
                  <a
                    style={{
                      fontSize: 18,
                      backgroundColor: "#f4f4f5",
                      fontWeight: 600,
                      paddingRight: 10,
                      marginBottom: 20,
                    }}
                  >
                    Fill All
                  </a>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Product Name
                  </a>
                </div>
                <TextField
                  id="standard-basic"
                  label="Product name"
                  variant="standard"
                  name="name"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.name}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Brand/s
                  </a>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                  {/* <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Brand/s
                  </a> */}
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="brand-select-label"
                        id="brand-select"
                        value={ProductOBJ.product.brand || ""}
                        onChange={handleChangeBrands}
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 300,
                            },
                          },
                          disableAutoFocusItem: true,
                        }}
                        onOpen={() => {
                          setSearchTermBrands("");
                          setTimeout(() => searchInputRef.current?.focus(), 0);
                        }}
                      >
                        {/* Search input with clear button */}
                        <Box
                          sx={{
                            p: 1,
                            borderBottom: "1px solid #eee",
                            position: "sticky",
                            top: 0,
                            bgcolor: "background.paper",
                            zIndex: 1,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <TextField
                            fullWidth
                            inputRef={searchInputRef}
                            placeholder="Search brands..."
                            value={searchTermBrands}
                            onChange={(e) =>
                              setSearchTermBrands(e.target.value)
                            }
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                height: "32px",
                              },
                            }}
                            onKeyDown={(e) => e.stopPropagation()}
                            autoFocus
                            InputProps={{
                              endAdornment: searchTermBrands && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    onClick={clearSearch}
                                    edge="end"
                                  >
                                    <ClearIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>

                        {/* Filtered options */}
                        {filteredBrands.length === 0 ? (
                          <MenuItem disabled sx={{ p: 1 }}>
                            <Typography variant="body2" color="textSecondary">
                              No brands found matching "{searchTermBrands}"
                            </Typography>
                          </MenuItem>
                        ) : (
                          filteredBrands.map((option) => (
                            <MenuItem
                              key={option.value}
                              value={option.value}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                                },
                                "&.Mui-selected:hover": {
                                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                                },
                              }}
                            >
                              <ListItemText
                                primary={option.label}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: 14,
                                    margin: 0,
                                  },
                                }}
                              />
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>
                {/* <TextField
                  id="standard-basic"
                  label="Brand"
                  variant="standard"
                  name="brand"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.brand}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                /> */}

                {/* <TextField
                  id="standard-basic"
                  label="Image"
                  variant="standard"
                  name="image"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.image}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                /> */}
                <input
                  type="file"
                  accept="image/*"
                  name="image"
                  onChange={handleFileChange}
                  style={{ marginBottom: 20 }}
                />
                {/* {ProductOBJ.product.image && (
                  <div>Selected image: {ProductOBJ.product.image}</div>
                )} */}

                <TextField
                  id="standard-basic"
                  label="Price"
                  variant="standard"
                  name="price"
                  type="number" // This restricts input to numbers
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*", // Ensures only numbers on mobile devices
                  }}
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.price}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="Price instead of"
                  variant="standard"
                  name="priceInsteadOf"
                  type="number" // This restricts input to numbers
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*", // Ensures only numbers on mobile devices
                  }}
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.priceInsteadOf}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    which category ?*
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="Category"
                        id="standard-basic"
                        name="category" // Important: matches the property name in state
                        value={ProductOBJ.product.category}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 200,
                            },
                          },
                        }}
                      >
                        {Categories.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>

                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Is Gift ?
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="IsGift"
                        id="standard-basic"
                        name="IsGift" // Important: matches the property name in state
                        value={ProductOBJ.product.IsGift}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                            },
                          },
                        }}
                      >
                        {ItIsGift.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>
                {ProductOBJ.product.IsGift === 2 ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                        Name the gift to find it!
                      </a>
                    </div>
                    <TextField
                      id="standard-basic"
                      label="Check gift name"
                      variant="standard"
                      name="CheckGiftName"
                      style={{
                        paddingBottom: 30,
                        width: "100%",
                        fontSize: 10,
                      }}
                      InputLabelProps={{
                        style: { color: "#a1a1aa", fontSize: "14px" },
                      }}
                      value={ProductOBJ.product.CheckGiftName}
                      onChange={handleInputChange}
                      sx={textFieldStyles}
                    />
                  </>
                ) : (
                  <></>
                )}

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Drop down or dialog ?
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="Drop down or dialog"
                        id="standard-basic"
                        name="DropDownOrDialog" // Important: matches the property name in state
                        value={ProductOBJ.product.DropDownOrDialog}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                            },
                          },
                        }}
                      >
                        {DropDownOrDialog.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    BigCategoryFilter{" "}
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="big-category-filter-label"
                        id="big-category-filter"
                        multiple
                        value={selectedValuesBigCategoryFilter}
                        onChange={handleChangeBigCategoryFilter}
                        renderValue={(selected) =>
                          selected
                            .map((val) => {
                              const item = CategoriesData.find(
                                (option) => option.value === val,
                              );
                              return item ? item.label : val;
                            })
                            .join(", ")
                        }
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 300,
                            },
                          },
                          // Disable focus management that interferes with search
                          disableAutoFocus: true,
                          disableEnforceFocus: true,
                          disableRestoreFocus: true,
                        }}
                        onOpen={() => setSearchTermBigCategoryFilter("")}
                      >
                        {/* Search input with focus management */}
                        <Box
                          sx={{
                            p: 1,
                            borderBottom: "1px solid #eee",
                            position: "sticky",
                            top: 0,
                            bgcolor: "background.paper",
                            zIndex: 1,
                          }}
                        >
                          <TextField
                            fullWidth
                            inputRef={searchInputRef}
                            placeholder="Search brands..."
                            value={searchTermBigCategoryFilter}
                            onChange={(e) =>
                              setSearchTermBigCategoryFilter(e.target.value)
                            }
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                height: "32px",
                              },
                            }}
                            onKeyDown={(e) => e.stopPropagation()} // Prevent select from handling key events
                          />
                        </Box>

                        {/* Filtered options or no results message */}
                        {CategoriesData.filter(
                          (option) =>
                            option.label
                              .toLowerCase()
                              .includes(
                                searchTermBigCategoryFilter.toLowerCase(),
                              ) ||
                            option.value
                              .toString()
                              .toLowerCase()
                              .includes(
                                searchTermBigCategoryFilter.toLowerCase(),
                              ),
                        ).length === 0 ? (
                          <MenuItem disabled sx={{ p: 1 }}>
                            <Typography variant="body2" color="textSecondary">
                              No brands found matching "
                              {searchTermBigCategoryFilter}"
                            </Typography>
                          </MenuItem>
                        ) : (
                          CategoriesData.filter(
                            (option) =>
                              option.label
                                .toLowerCase()
                                .includes(
                                  searchTermBigCategoryFilter.toLowerCase(),
                                ) ||
                              option.value
                                .toString()
                                .toLowerCase()
                                .includes(
                                  searchTermBigCategoryFilter.toLowerCase(),
                                ),
                          ).map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              <Checkbox
                                style={{ paddingTop: 3 }}
                                icon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <Box
                                    sx={{
                                      width: 18,
                                      height: 18,
                                      border: "1.4px solid black",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 10,
                                        height: 10,
                                        backgroundColor: "black",
                                      }}
                                    />
                                  </Box>
                                }
                                checked={selectedValuesBigCategoryFilter.includes(
                                  option.value,
                                )}
                                sx={{ padding: 0 }}
                              />
                              <ListItemText
                                primary={option.label}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: 14,
                                    margin: 0,
                                  },
                                }}
                              />
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>
                <TextField
                  id="standard-basic"
                  label="Drop down"
                  variant="standard"
                  name="DropDown"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.DropDown}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    Which Main category ?*
                  </a>
                </div>
                <ThemeProvider theme={theme}>
                  <Box
                    style={{
                      paddingBottom: 30,
                      //width: MyWidth <= 1024 ? "90%" : "80%",
                      width: "100%",
                      fontSize: 10,
                      //paddingTop: 30,
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="Main Page Call Cat Name"
                        id="standard-basic"
                        name="mainPageCallCatName" // Important: matches the property name in state
                        value={ProductOBJ.product.mainPageCallCatName}
                        onChange={handleInputChange} // Use the shared handler
                        sx={SelectStyles}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1px solid #a1a1aa",
                              borderRadius: 0,
                              boxShadow: "none",
                              fontSize: 14,
                              maxHeight: 200,
                            },
                          },
                        }}
                      >
                        {MainPageCategories.map((option) => (
                          <MenuItem
                            key={option.value}
                            style={{ fontSize: 14 }}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </ThemeProvider>
                <div style={{ display: "flex", width: "100%" }}>
                  <a
                    style={{
                      fontSize: 18,
                      backgroundColor: "#f4f4f5",
                      fontWeight: 600,
                      paddingRight: 10,
                      marginBottom: 20,
                    }}
                  >
                    End Fill All
                  </a>
                </div>

                <div style={{ display: "flex", width: "100%" }}>
                  <a
                    style={{
                      fontSize: 18,
                      backgroundColor: "#f4f4f5",
                      fontWeight: 600,
                      paddingRight: 10,
                      marginBottom: 20,
                    }}
                  >
                    Here fill by category needs!
                  </a>
                </div>
                <TextField
                  id="standard-basic"
                  label="Product type"
                  variant="standard"
                  name="productType"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.productType}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <TextField
                  id="standard-basic"
                  label="Classfication"
                  variant="standard"
                  name="classfication"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.classfication}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                {ChooseCat === "Health and Care" ? (
                  <></>
                ) : (
                  <TextField
                    id="standard-basic"
                    label="Product properties"
                    variant="standard"
                    name="productProperties"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.productProperties}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                )}
                <div style={{ display: "flex", width: "100%" }}>
                  <a style={{ fontSize: 14, backgroundColor: "#f4f4f5" }}>
                    What gender ?*
                  </a>
                </div>
                {ChooseCat === "For Men" || ChooseCat === "Health and Care" ? (
                  <></>
                ) : (
                  <ThemeProvider theme={theme}>
                    <Box
                      style={{
                        paddingBottom: 30,
                        //width: MyWidth <= 1024 ? "90%" : "80%",
                        width: "100%",
                        fontSize: 10,
                        //paddingTop: 30,
                      }}
                    >
                      <FormControl fullWidth>
                        <Select
                          labelId="Gender"
                          id="standard-basic"
                          name="gender" // Important: matches the property name in state
                          value={ProductOBJ.product.gender}
                          onChange={handleInputChange} // Use the shared handler
                          sx={SelectStyles}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                border: "1px solid #a1a1aa",
                                borderRadius: 0,
                                boxShadow: "none",
                                fontSize: 14,
                              },
                            },
                          }}
                        >
                          {Gender.map((option) => (
                            <MenuItem
                              key={option.value}
                              style={{ fontSize: 14 }}
                              value={option.value}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </ThemeProvider>
                )}

                {ChooseCat === "Perfume" ? (
                  <TextField
                    id="standard-basic"
                    label="Scent type"
                    variant="standard"
                    name="scentType"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.scentType}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}
                {ChooseCat === "Perfume" || ChooseCat === "For Men" ? (
                  <TextField
                    id="standard-basic"
                    label="Top note"
                    variant="standard"
                    name="topNote"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.topNote}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}
                {ChooseCat === "Perfume" ? (
                  <TextField
                    id="standard-basic"
                    label="Heart note"
                    variant="standard"
                    name="heartNote"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.heartNote}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}

                {ChooseCat === "Perfume" ? (
                  <TextField
                    id="standard-basic"
                    label="Base note"
                    variant="standard"
                    name="baseNote"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.baseNote}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}

                {ChooseCat === "For Men" || ChooseCat === "Accessories" ? (
                  <></>
                ) : (
                  <TextField
                    id="standard-basic"
                    label="Ingredients"
                    variant="standard"
                    name="ingredients"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.ingredients}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                )}

                <TextField
                  id="standard-basic"
                  label="Special certificates"
                  variant="standard"
                  name="specialCertificates"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.specialCertificates}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />

                {ChooseCat === "Health and Care" || ChooseCat === "Gifts" ? (
                  <></>
                ) : (
                  <TextField
                    id="standard-basic"
                    label="Volume"
                    variant="standard"
                    name="volume"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.volume}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                )}

                {ChooseCat === "Health and Care" ? (
                  <></>
                ) : (
                  <TextField
                    id="standard-basic"
                    label="Made in"
                    variant="standard"
                    name="madeIn"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.madeIn}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                )}
                {ChooseCat === "Perfume" ||
                ChooseCat === "Accessories" ||
                ChooseCat === "Health and Care" ||
                ChooseCat === "Gifts" ? (
                  <></>
                ) : (
                  <TextField
                    id="standard-basic"
                    label="Color"
                    variant="standard"
                    name="color"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.color}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                )}

                {ChooseCat === "Makeup" ? (
                  <TextField
                    id="standard-basic"
                    label="Protection level"
                    variant="standard"
                    name="ProtectionLevel"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.ProtectionLevel}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}
                {ChooseCat === "Makeup" ? (
                  <TextField
                    id="standard-basic"
                    label="Eyeshadow effect"
                    variant="standard"
                    name="EyeshadowEffect"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.EyeshadowEffect}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}

                {ChooseCat === "Makeup" ? (
                  <TextField
                    id="standard-basic"
                    label="Formula"
                    variant="standard"
                    name="Formula"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.Formula}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}

                {ChooseCat === "Perfume" ||
                ChooseCat === "Health and Care" ||
                ChooseCat === "Gifts" ? (
                  <></>
                ) : (
                  <TextField
                    id="standard-basic"
                    label="Country"
                    variant="standard"
                    name="country"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.country}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                )}

                {ChooseCat === "Hair" || ChooseCat === "Accessories" ? (
                  <TextField
                    id="standard-basic"
                    label="Hair type"
                    variant="standard"
                    name="HairType"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.HairType}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}
                {ChooseCat === "Hair" ? (
                  <TextField
                    id="standard-basic"
                    label="Brush material"
                    variant="standard"
                    name="BrushMaterial"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.BrushMaterial}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}
                {ChooseCat === "Face" ||
                ChooseCat === "Bath and Body" ||
                ChooseCat === "For Men" ||
                ChooseCat === "Accessories" ? (
                  <TextField
                    id="standard-basic"
                    label="Skin type"
                    variant="standard"
                    name="SkinType"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.SkinType}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}
                {ChooseCat === "Accessories" || ChooseCat === "Gifts" ? (
                  <TextField
                    id="standard-basic"
                    label="Age"
                    variant="standard"
                    name="age"
                    style={{
                      paddingBottom: 30,
                      width: "100%",
                      fontSize: 10,
                    }}
                    InputLabelProps={{
                      style: { color: "#a1a1aa", fontSize: "14px" },
                    }}
                    value={ProductOBJ.product.age}
                    onChange={handleInputChange}
                    sx={textFieldStyles}
                  />
                ) : (
                  <></>
                )}

                <TextField
                  id="standard-basic"
                  label="Line"
                  variant="standard"
                  name="Line"
                  style={{
                    paddingBottom: 30,
                    width: "100%",
                    fontSize: 10,
                  }}
                  InputLabelProps={{
                    style: { color: "#a1a1aa", fontSize: "14px" },
                  }}
                  value={ProductOBJ.product.Line}
                  onChange={handleInputChange}
                  sx={textFieldStyles}
                />
                <button
                  style={{
                    backgroundColor: isCreating ? "#52525b" : "#27272a",
                    color: "#fff",
                    border: "none",
                    cursor: isCreating ? "not-allowed" : "pointer",
                    fontSize: "16px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    opacity: isCreating ? 0.7 : 1,
                  }}
                  onClick={() => {
                    if (!isCreating) {
                      handleSignup();
                    }
                  }}
                  disabled={isCreating}
                >
                  {isCreating ? (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <div
                        style={{
                          width: 16,
                          height: 16,
                          border: "2px solid #fff",
                          borderTopColor: "transparent",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      <a style={{ fontSize: 14 }}>Creating...</a>
                    </div>
                  ) : (
                    <a style={{ fontSize: 14 }}>Create</a>
                  )}
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  };

  const handleSignup = async () => {
    if (!imageFile) {
      alert("No image selected");
      return;
    }

    setIsCreating(true); // Start loading

    try {
      // 1. Create the product first WITHOUT image URL
      const productCreationData = {
        ...ProductOBJ,
        product: {
          ...ProductOBJ.product,
          image: "", // no image URL yet
        },
      };

      const createResponse = await axios.post(
        `${MyDomain}Products/CreateNewProduct`,
        productCreationData,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const createdProduct = createResponse.data;
      const productId =
        createdProduct.id || createdProduct.Id || createdProduct.productId;

      // 2. Generate a custom blob name using the product ID + file extension
      const extension = imageFile.name.split(".").pop();
      const blobName = encodeURIComponent(`${productId}.${extension}`);

      // 3. Request SAS URL from backend for the custom blob name
      const sasResponse = await axios.get(`${MyDomain}api/blob/generate-sas`, {
        params: { blobName },
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });

      const { uploadUrl, blobUrl } = sasResponse.data;

      // 4. Upload image file to Azure Blob Storage with SAS URL
      await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": imageFile.type,
        },
        body: imageFile,
      });

      // 5. Update product image URL on backend
      await axios.put(
        `${MyDomain}Products/UpdateImage/${productId}`,
        { imageUrl: blobUrl },
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setOpen(false);
      setProductOBJ({
        product: {
          name: "",
          brand: "",
          image: "",
          price: 0,
          discount: 0,
          category: "",
          IsGift: 1,
          NewsCodeCat: 0,
          numberUsersRating: 0,
          rating: "",
          inWishList: "",
          deals: "",
          inStock: "Yes",
          DropDown: "",
          TheDeal: 1,
          DropDownOrDialog: 1,
          mainimage: "",
          DatePost: formattedDate,
          CheckGiftName: "",
          DateCreateProduct: formattedDate,
          BigCategoryFilter: "",
          priceInsteadOf: 0,
          mainPageCallCatName: "",
          productType: "Eau de parfum",
          classfication: "Elite",
          productProperties: "",
          gender: "For women",
          scentType: "",
          topNote: "",
          heartNote: "",
          baseNote: "",
          ingredients: "",
          specialCertificates: "",
          volume: "",
          madeIn: "France",
          color: "",
          ProtectionLevel: "",
          EyeshadowEffect: "",
          Formula: "",
          country: "",
          HairType: "",
          BrushMaterial: "",
          SkinType: "",
          age: "",
          Line: "",
        },
        productDisc: {
          characteristics: "Characteristics",
          discreption: "Description",
          howToUse: "Instructions",
        },
      });

      alert("Product created and image uploaded successfully!");
    } catch (error) {
      console.error(
        "Error during product creation or image upload:",
        error.response?.data || error.message,
      );
      alert("Failed to create product or upload image.");
    } finally {
      setIsCreating(false); // Stop loading
    }
  };
  if (loading) return <a>loading...</a>;
  if (error) return <a>{error}</a>;

  return (
    <div>
      <div
        style={{
          display: "grid",
          //gridTemplateColumns: "repeat(5, 1fr)",
          gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",

          gap: "16px",
          padding: "16px",
        }}
      >
        {ChoosingCategory.map((Cat) => (
          <div
            key={Cat}
            style={{
              backgroundColor: ChooseCat === Cat ? "#27272a" : "white",
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid black",
              cursor: "pointer",
            }}
            onClick={() => {
              setChooseCat(Cat);
            }}
          >
            <a style={{ color: ChooseCat === Cat ? "white" : "black" }}>
              {Cat}
            </a>
          </div>
        ))}
      </div>
      {ModalCreateNewProduct()}

      <button
        style={{
          //marginTop: 20,
          backgroundColor: "#27272a",
          color: "#fff",
          border: "none",
          //padding: "10px 20px",
          cursor: "pointer",
          fontSize: "16px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 50,
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <a onClick={() => {}} style={{ cursor: "pointer" }}>
          Create new product
        </a>
      </button>
    </div>
  );
}
